import { render, staticRenderFns } from "./PaperList.vue?vue&type=template&id=879da302"
import script from "./PaperList.vue?vue&type=script&lang=ts"
export * from "./PaperList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports